import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// 防止不跳转页面，只修改路由参数报错
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.replace = function (location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      title: "Home",
      deepth: 0.5,
      keepAlive: true, //需要被缓存
    },
    component: () => import("@/views/Index.vue"),
  },
  {
    path: "/KA",
    name: "KA",
    meta: {
      title: "Home",
      deepth: 0.5,
      keepAlive: true, //需要被缓存
    },
    component: () => import("@/views/KaIndex.vue"),
  },
  {
    path: "/pbl",
    name: "pbl",
    meta: {
      title: "Home",
      deepth: 0.5,
      keepAlive: true, //需要被缓存
    },
    component: () => import("@/views/pbl/index.vue"),
  },
  {
    path: "/home/:type/:isOpen?",
    name: "Home",
    meta: {
      title: "Home",
      deepth: 0.5,
      keepAlive: true, //需要被缓存
    },
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/List/:type?/:id?",
    name: "List",
    meta: {
      title: "Course List",
      deepth: 1,
      keepAlive: true, //需要被缓存
      scrollTop: 0,
    },
    component: () => import("@/views/List/index.vue"),
  },
  {
    path: "/Lists/:type?/:id?",
    name: "Lists",
    meta: {
      title: "Course List",
      deepth: 1,
      keepAlive: true, //需要被缓存
      scrollTop: 0,
    },
    component: () => import("@/views/List/index.vue"),
  },
  {
    path: "/ListsA/:type?/:id?",
    name: "redirct",
    meta: {
      title: "Course List",
      deepth: 1,
      keepAlive: true, //需要被缓存
      scrollTop: 0,
    },
    component: () => import("@/views/redirct/index.vue"),
  },

  {
    path: "/BillClassify",
    name: "BillClassify",
    meta: {
      title: "Poster",
      deepth: 2,
    },
    component: () => import("@/views/BillClassify.vue"),
  },
  {
    path: "/aisBillClassify",
    name: "aisBillClassify",
    meta: {
      title: "Poster",
      deepth: 2,
    },
    component: () => import("@/views/aisBillClassify.vue"),
  },
  {
    path: "/aisBillClassify2",
    name: "aisBillClassify2",
    meta: {
      title: "Poster",
      deepth: 2,
    },
    component: () => import("@/views/aisBillClassify2.vue"),
  },
  {
    path: "/BillClassify2",
    name: "BillClassify2",
    meta: {
      title: "Poster",
      deepth: 2,
    },
    component: () => import("@/views/BillClassify2.vue"),
  },
  {
    path: "/BillOverseas",
    name: "BillOverseas",
    meta: {
      title: "Poster",
      deepth: 2,
    },
    component: () => import("@/views/BillOverseas.vue"),
  },
  {
    path: "/BillClassify3",
    name: "BillClassify3",
    meta: {
      title: "Poster",
      deepth: 2,
    },
    component: () => import("@/views/BillClassify3.vue"),
  },
  {
    path: "/Professor",
    name: "Professor",
    meta: {
      title: "Course Poster",
      deepth: 2,
    },
    component: () => import("@/views/Professor.vue"),
  },
  {
    path: "/Detail",
    name: "Detail",
    meta: {
      title: "",
      deepth: 1.5,
      keepAlive: true, //需要被缓存
    },
    component: () => import("@/views/Detail.vue"),
  },
  {
    path: "/Disclaimers",
    name: "Disclaimers",
    meta: {
      title: "Disclaimers",
    },
    component: () => import("@/views/Disclaimers.vue"),
  },
  {
    path: "/CalendarDetail",
    name: "CalendarDetail",
    meta: {
      title: "",
      deepth: 2,
    },
    component: () => import("@/views/CalendarDetail.vue"),
  },
  {
    path: "/school",
    name: "School",
    meta: {
      title: "校区展示",
    },
    component: () => import("@/views/School.vue"),
  },
  {
    path: "/schooldetail",
    name: "SchoolDetail",
    meta: {
      title: "",
    },
    component: () => import("@/views/SchoolDetail.vue"),
  },
  {
    path: "/school2",
    name: "School2",
    component: () => import("@/views/School2.vue"),
  },
  {
    path: "/school3",
    name: "School3",
    component: () => import("@/views/School3.vue"),
  },

  {
    path: "/posters",
    name: "Posters",
    meta: {
      title: "",
    },
    component: () => import("@/views/Posters.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("@/views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
